//
// Component: Card
//
// Displays and controls a player's cards
//

// dependencies
import React from 'react'
import { Image } from 'rebass'

// Stylesheet
import './cards.css'

// components
import P from 'App/components/text/P.js'

// stores
// import GameStore from 'App/stores/GameStore'

class Card extends React.Component {
  //
  // props
  //
  // hand - north, south, east, west
  // horizontalCard - true/false - orientation of card
  // horizontalHand - true/false - orientation of hand the card belongs to
  // id - card identifier eg. north1, north2 etc
  // rank - A, 2, 3 ... J, Q, K
  // suit - S, H, D, C
  // visible - true/false - if false the back of the card will be shown
  //

  constructor (props) {
    super(props)
    this.state = {
    }
    this.handleCardClicked = this.handleCardClicked.bind(this)
  }

  componentDidMount () {

  }

  handleCardClicked () {
    // Only do this for north & south otherwise player
    // can play a card from bots hands
    // if (this.props.hand === 'north' || this.props.hand === 'south') {
    // console.log('handleCardClicked', this.props)

    const declarerMap = {
      north: 'south',
      south: 'north',
      east: 'west',
      west: 'east'
    }

    if (this.props.dummy && (declarerMap[this.props.currentPlayer] !== this.props.hand && this.props.currentPlayer !== this.props.hand)) {
      return
    }

    this.props.cardClicked(this.props.hand, this.props.rank, this.props.suit)
  }

  render () {
    var card = <P />
    var marginTop
    var marginLeft
    var mobileWidth = 45
    var desktopWidth = 70
    var mobileHeight = Math.floor(mobileWidth * 1.4)
    var desktopHeight = Math.floor(desktopWidth * 1.4)

    if (!this.props.visible) {
      card = (
        <Image
          // sx={{
          //   width: [mobileWidth, desktopWidth],
          //   height: [mobileHeight, desktopHeight],
          // }}
          draggable={false} className={'card ' + (this.props.horizontalCard ? 'hcard ' : 'vcard ') + (this.props.hand)} src={require('./images/2B.svg')}
        />
      )
    } else if (this.props.rank && this.props.rank !== '-' && this.props.suit) {
      card = (
        <Image
          // sx={{
          //   width: [mobileWidth, desktopWidth],
          //   height: [mobileHeight, desktopHeight],
          // }}
          draggable={false} id={this.props.id} className={'card ' + (this.props.hand || '') + ' ' + (this.props.table === 'true' ? 'table' : '') + ' ' + (this.props.horizontalCard ? 'hcard' : 'vcard')} src={require('./images/' + this.props.rank + this.props.suit + '.svg')} onClick={this.handleCardClicked}
        />
      )
    }
    return card
  }
}
export default Card
